/* Path definitions for routing
---------------------------------------------*/

// pages
export const PATH_HOME = '/';
export const PATH_REGISTRATION = '/registration';
export const PATH_REGISTRATION_DETAILS = '/registration_details';
export const PATH_REGISTRATION_COMMERCIAL = '/commercial_consent';
export const PATH_REGISTRATION_PROVIDER = '/provider_consent';
export const PATH_REGISTRATION_CONSENTS = '/consent';
export const PATH_REGISTRATION_CONFIRMATION = '/verify_account';
export const PATH_REGISTRATION_DONE = '/registration_done';
export const PATH_PORTABILITY = '/portability';
export const PATH_SUBPROFILE_REGISTRATION = '/subprofile_registration';
export const PATH_SUBPROFILE_LOGIN = '/subprofile_login';
export const PATH_SUBPROFILE_SELECTION = '/subprofile_selection';
export const PATH_SUBPROFILE_REGISTRATION_DETAILS = '/subprofile_registration_details';
export const PATH_SUBPROFILE_LOGIN_VERIFICATION = '/kids';
export const PATH_SUBPROFILE_LOGGED_IN_CHILD = '/subprofile_logged_in_child';
export const PATH_SUBPROFILE_LOGGED_IN_PARENT = '/subprofile_logged_in_parent';
export const PATH_FORGOT_PASSWORD = '/wachtwoord-vergeten';
export const PATH_FORGOT_PASSWORD_PENDING = '/wachtwoord-aangevraagd';
export const PATH_RESET_PASSWORD = '/wachtwoord-wijzigen';
export const PATH_RESET_PASSWORD_DONE = '/wachtwoord-aangepast';
export const PATH_LINK_ACCOUNTS = '/link_account';
export const PATH_SOCIAL_EMAIL = '/link_email';
export const PATH_CANCEL_LOGIN = '/cancel_login';
export const PATH_TV_VERIFICATION = '/tv';
export const PATH_TV_LINKED = '/tv_linked';

// 404 path
export const PATH_NO_MATCH = '*';

export const PAGE_TITLES = {
  [PATH_HOME]: 'Aanmelden',
  [PATH_REGISTRATION]: 'Registratie',
  [PATH_REGISTRATION_DETAILS]: 'Vertel meer over jezelf',
  [PATH_REGISTRATION_COMMERCIAL]: 'Gepersonaliseerde advertenties',
  [PATH_REGISTRATION_PROVIDER]: 'Kijkgedrag delen',
  [PATH_REGISTRATION_CONSENTS]: 'Nog even dit',
  [PATH_REGISTRATION_CONFIRMATION]: 'Registratie bevestigen',
  [PATH_REGISTRATION_DONE]: 'Profiel geverifieerd',
  [PATH_PORTABILITY]: 'Bevestig je VRT-profiel',
  [PATH_SUBPROFILE_REGISTRATION]: 'Wie ben jij?',
  [PATH_SUBPROFILE_LOGIN]: 'Laat je ouder aanmelden',
  [PATH_SUBPROFILE_SELECTION]: 'Selecteer een kidsprofiel',
  [PATH_SUBPROFILE_REGISTRATION_DETAILS]: 'Vertel meer over je kind',
  [PATH_SUBPROFILE_LOGIN_VERIFICATION]: 'Kidsprofiel aanmelden',
  [PATH_SUBPROFILE_LOGGED_IN_CHILD]: 'Profiel aangemeld',
  [PATH_SUBPROFILE_LOGGED_IN_PARENT]: 'Kidsprofiel aangemeld',
  [PATH_FORGOT_PASSWORD]: 'Wachtwoord vergeten',
  [PATH_FORGOT_PASSWORD_PENDING]: 'Wachtwoord wijzigen',
  [PATH_RESET_PASSWORD]: 'Wijzig je wachtwoord',
  [PATH_RESET_PASSWORD_DONE]: 'Wachtwoord gewijzigd',
  [PATH_LINK_ACCOUNTS]: 'Oude bekende',
  [PATH_SOCIAL_EMAIL]: 'E-mailadres aanvullen',
  [PATH_TV_VERIFICATION]: 'Koppel je toestel',
  [PATH_TV_LINKED]: 'Toestel gekoppeld',
  [PATH_NO_MATCH]: 'Er ging iets mis',
};

export const EBA_PAGE_IDS = {
  [PATH_HOME]: 'profiel-aanmelden',
  [PATH_REGISTRATION]: 'profiel-registreren',
  [PATH_REGISTRATION_DETAILS]: 'profiel-gegevens',
  [PATH_REGISTRATION_COMMERCIAL]: 'profiel-consent-advertenties',
  [PATH_REGISTRATION_PROVIDER]: 'profiel-consent-kijkgedrag',
  [PATH_REGISTRATION_CONSENTS]: 'profiel-consent',
  [PATH_REGISTRATION_CONFIRMATION]: 'profiel-bevestigen',
  [PATH_REGISTRATION_DONE]: 'profiel-bevestigd',
  [PATH_PORTABILITY]: 'profiel-portabiliteit',
  [PATH_SUBPROFILE_REGISTRATION]: 'profiel-kids-registreren',
  [PATH_SUBPROFILE_LOGIN]: 'profiel-kids-activatie',
  [PATH_SUBPROFILE_SELECTION]: 'profiel-kids-profiel-selectie',
  [PATH_SUBPROFILE_REGISTRATION_DETAILS]: 'profiel-kids-gegevens-als-ouder',
  [PATH_SUBPROFILE_LOGIN_VERIFICATION]: 'profiel-kids-verificatie-ouder',
  [PATH_SUBPROFILE_LOGGED_IN_CHILD]: 'profiel-kids-bevestiging-kind',
  [PATH_SUBPROFILE_LOGGED_IN_PARENT]: 'profiel-kids-bevestiging-ouder',
  [PATH_FORGOT_PASSWORD]: 'profiel-wachtwoord-vergeten',
  [PATH_FORGOT_PASSWORD_PENDING]: 'profiel-wachtwoord-wijzigen-aangevraagd',
  [PATH_RESET_PASSWORD]: 'profiel-wachtwoord-wijzigen',
  [PATH_RESET_PASSWORD_DONE]: 'profiel-wachtwoord-gewijzigd',
  [PATH_LINK_ACCOUNTS]: 'profiel-accounts-koppelen',
  [PATH_SOCIAL_EMAIL]: 'profiel-email-aanvullen',
  [PATH_TV_VERIFICATION]: 'profiel-toestel-verificatie',
  [PATH_TV_LINKED]: 'profiel-toestel-gekoppeld',
  [PATH_NO_MATCH]: 'profiel-foutboodschap',
};
